export default __webpack_public_path__ + "static/media/contactImage.2bcbabb4.jpg";